import React from "react";
import FormReview from "../../../components/Compos Validation/index.js";

/**
 * Modal de conferência/revisão dos dados do TCA CIEEMG Empregador.
 *
 * @param {object} props
 * @param {boolean} props.showReview - Controla visibilidade
 * @param {Function} props.onClose - Callback disparado para fechar modal
 * @param {Array} props.reviewData - Lista de seções gerada pelo review builder
 * @param {Function} props.onEditSection - Callback para navegar/editar seção
 * @param {Function} props.onSubmit - Callback disparado após confirmação
 */
export const TcaEmpregadorReviewModal = ({
  showReview,
  onClose,
  reviewData,
  onEditSection,
  onSubmit,
}) => {
  if (!showReview) return null;

  return (
    <div
      className="tca-modal-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      role="dialog"
      aria-modal="true"
    >
      <div className="tca-modal-content">
        <FormReview
          data={reviewData}
          onEdit={onEditSection}
          onSubmit={onSubmit}
          confirmMessage="Tem certeza que deseja enviar o TCA CIEEMG Empregador?"
        />
      </div>
    </div>
  );
};

export default TcaEmpregadorReviewModal;
